(function(){

let currentCount = -1

function renderMessage(count){
  currentCount = count

  const message = document.getElementById("shock-progress-message")
  if(!message) return

  let text = ""
  if(count === 0){
    text = "Add <b>2 items</b> to unlock <b>10% off</b> your order 🛍️"
  } else if(count === 1){
    text = "Add <b>1 more item</b> to unlock <b>10% off</b> your entire order ✨"
  } else if(count === 2){
    text = "🎉 <b>10% off unlocked!</b> Add 1 more item & get <b>20% off</b>"
  } else {
    text = "🔥 <b>20% off applied!</b> Your discount has been unlocked"
  }

  message.style.transition = "none"
  message.style.opacity = "0"
  message.innerHTML = text
  // Pequeno delay pra garantir que o browser pintou o opacity:0 antes de animar
  requestAnimationFrame(() => {
    message.style.transition = "opacity 0.2s ease"
    message.style.opacity = "1"
  })
}

function handleCartUpdate(e){
  const count = e?.detail?.resource?.item_count
  if(typeof count === "number") renderMessage(count)
}

function init(){
  const message = document.getElementById("shock-progress-message")
  if(message) message.style.opacity = "0"

  // cart:update: fonte de verdade — renderiza com count correto
  document.addEventListener("cart:update", handleCartUpdate)

  // Observa o body inteiro para detectar quando shock-progress-message
  // é recriado pelo morphSection e reaplicar o count correto
  new MutationObserver(() => {
    if(currentCount < 0) return
    const message = document.getElementById("shock-progress-message")
    if(!message) return
    // Se a mensagem existe mas está com texto errado (vazio ou padrão), corrige
    if(message.dataset.count !== String(currentCount)){
      message.dataset.count = String(currentCount)
      renderMessage(currentCount)
    }
  }).observe(document.body, { childList: true, subtree: true })

  // Primeira abertura do drawer — fetch
  const dialog = document.querySelector(".cart-drawer__dialog")
  if(dialog){
    new MutationObserver((mutations) => {
      mutations.forEach(m => {
        if(m.attributeName === "open" && dialog.hasAttribute("open") && currentCount < 0){
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => renderMessage(cart.item_count || 0))
            .catch(() => {})
        }
      })
    }).observe(dialog, { attributes: true, attributeFilter: ["open"] })

    if(dialog.hasAttribute("open") && currentCount < 0){
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => renderMessage(cart.item_count || 0))
        .catch(() => {})
    }
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}

})();